import React from 'react';
import ReactPlayer from 'react-player';
import VideoPlayer from './../../../components/video-player/VideoPlayer';
import ImageStack from './../../../components/ImageStack';
import CopyWrapper from './copy_wrapper';
import GridItem from './grid_item';
import ExPubSwiper from './../../ex-pub-gallery/ExPubSwiper';

const FlexItem = (props) => {
  return (
    <div className={
      (props.Item.copy) ? 'copy-row flexible-row' :
      (props.Item.video) ? 'video-row flexible-row' :
      (props.Item.audio) ? 'audio-row flexible-row' :
      (props.Item.image_stack) ? 'image-stack-row flexible-row' :
      (props.Item.slideshow) ? 'slideshow-row flexible-row' : 'flexible-row'}>
      {(props.Item.two_column)
        ? <div className={'two_column flex-row-wrapper'}>
            <GridItem ImgData={props.Item.two_column[0]} ImgSize={'two_column'}/>
            <GridItem ImgData={props.Item.two_column[1]} ImgSize={'two_column'}/>
          </div>
        : (props.Item.image)
        ? <div className={props.Item.image.position + ' flex-row-wrapper'}>
            <GridItem ImgData={props.Item} ImgSize={props.Item.image.position}/>
          </div>
        : (props.Item.copy)
        ? <CopyWrapper Style={props.Item.copy.style} Copy={props.Item.copy}/>
        : (props.Item.audio)
        ? <ReactPlayer
            url={props.Item.audio.soundcloud_url}
            playing={false}
            config={{
              soundcloud: {
                options: {
                  color: '#000000',
                  sharing: false,
                  show_artwork: false,
                  show_user: false
                }
              }
            }}
          />
        : (props.Item.video)
        ? <VideoPlayer videoId={props.Item.video.vimeo_id} videoUrl={`https://vimeo.com/${props.Item.video.vimeo_id}`} videoPoster={props.Item.video.video_img.large} cta={'PLAY'}/>
        : (props.Item.slideshow)
        ? <ExPubSwiper Slides={props.Item.slideshow.slideshow_images}/>
        : (props.Item.image_stack)
        ? <div className={'flexible-image-stack copy'}>
            <div className="text-col" dangerouslySetInnerHTML={{__html:props.Item.image_stack.copy}} />
            <ImageStack imgs={props.Item.image_stack.images} />
          </div>
        : null
      }
    </div>
  );
};

export default FlexItem;



// WEBPACK FOOTER //
// ./src/pages/blog/blog_single/flex_item.js